"use client";

import { useRouter } from "@/i18n/navigation";
import { BackNav, Container, VStack } from "@/ui";
import { AddressForm } from "./AddressForm";
import { ProfileForm } from "./ProfileForm";

export const ProfileContainer = () => {
  const router = useRouter();
  return (
    <Container size={"md"}>
      <BackNav onBack={() => router.back()} />
      <VStack className={"gap-2"}>
        <ProfileForm />
        <AddressForm />
      </VStack>
    </Container>
  );
};
